import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  link: string,
  label: string,
  last?: boolean,
  reload?: boolean,
}

const NavLink = (props: Props): React.ReactElement => {
  const { link, label, last, reload } = props;
  const activeLink = '/';
  let liClasses = 'dropdown-item nav-item';
  if (last) {
    liClasses += ' last-ch';
  }
  if (link === activeLink) {
    liClasses += ' active';
  }

  return (
    <li className={liClasses}>
      {reload ? (
        <a className="nav-link" href={link}>{label}</a>
      ) : (
        <Link className="nav-link" to={link}>{label}</Link>
      )}
    </li>
  );
};

export default NavLink;
